export default __webpack_public_path__ + "static/media/MIERCOLES.88f67347.jpeg";